<template>
  <YzsDragDrawer
    v-model:visible="visible"
    :title="t('sysIssuesAndFeatureReq')"
    :getContainer="getContainer"
    :width="500"
    :zIndex="1001"
  >
    <div>
      <a-form
        ref="formRef"
        :model="formState"
        name="basic"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 16 }"
        autocomplete="off"
        @finish="handleSubmit"
      >
        <a-form-item
          :label="t('fileUpload')"
          name="feedbackFileUrlList"
          :label-col="{ span: 7 }"
          :rules="[]"
        >
          <div>
            <BaseUpload
              class="base-upload"
              style="width: 50%"
              @change="handleUplaodChange"
            ></BaseUpload>
            <div>
              <FileItem
                class="file-item"
                v-for="(item, index) in fileList"
                @delete="handleDelete"
                @click="handleClickFile(item)"
                :showDownload="true"
                :index="index"
                :key="index"
                :value="item"
              />
            </div>
          </div>
        </a-form-item>

        <a-form-item :label="t('mbl')" name="blNo" :label-col="{ span: 7 }">
          <a-input
            v-model:value="formState.blNo"
            :placeholder="`${t('pleaseEnter')}${t('mbl')}`"
          />
        </a-form-item>

        <a-form-item :label="t('containerNumber')" :label-col="{ span: 7 }" name="number">
          <a-input
            v-model:value="formState.number"
            :placeholder="`${t('pleaseEnter')}${t('containerNumber')}`"
          />
        </a-form-item>

        <a-form-item
          :label="t('truckPlateNumber')"
          :label-col="{ span: 7 }"
          name="truckPlateNumber"
        >
          <a-input
            v-model:value="formState.truckPlateNumber"
            :placeholder="`${t('pleaseEnter')}${t('truckPlateNumber')}`"
          />
        </a-form-item>
        <a-form-item :label="t('orderNumber')" :label-col="{ span: 7 }" name="orderNo">
          <a-input
            v-model:value="formState.orderNo"
            :placeholder="`${t('pleaseEnter')}${t('orderNumber')}`"
          />
        </a-form-item>
        <a-form-item
          :label="t('remark')"
          name="remark"
          :label-col="{ span: 7 }"
          :rules="[{ required: true, message: `${t('pleaseEnter')}${t('remark')}` }]"
        >
          <a-textarea
            v-model:value="formState.remark"
            :placeholder="t('remark')"
            :rows="4"
          />
        </a-form-item>
        <a-form-item
          :label="t('feedbackProvider')"
          :label-col="{ span: 7 }"
          name="feedbackUserId"
          :rules="[
            {
              required: true,
              message: t('pleaseSelectFeedbackProvider'),
              trigger: ['change', 'blur'],
            },
          ]"
        >
          <YzsEnumFuzzyCustomSelect
            v-model:value="formState.feedbackUserId"
            code="yzsOperator"
            conditionKey="inputText"
            :label="t('feedbackProvider')"
            :placeholder="t('pleaseSelectFeedbackProvider')"
            :selectProps="feedbackUserSelectProps"
            :showLabel="false"
            class="feedback-user-select"
          />
        </a-form-item>
      </a-form>

      <DragDrawerViewerFile ref="viewerFile"></DragDrawerViewerFile>
    </div>
    <template #footBtn>
      <a-button type="primary" :loading="postLoading" @click="handleSubmitClick">{{
        $t("submit")
      }}</a-button>
    </template>
  </YzsDragDrawer>
</template>
<script setup lang="ts">
// @ts-ignore
import { computed, reactive, ref, toRaw, watch } from "vue";
import { BaseUpload } from "@/components/BaseUpload";
import YzsFileService from "@/utils/YzsFileService";
// @ts-ignore
import { message } from "ant-design-vue";
import { checkFileType } from "@/components/BaseUpload/mimeType";
import DragDrawerViewerFile from "@/components/DragDrawerViewerFile.vue";
import { apiPostProblemfeedback } from "@/api/problemfeedback";
import { FileInfo } from "../BaseUpload/type";
import { useI18n } from "vue-i18n";
const { t } = useI18n();
const fileList: any = reactive([]);
const formRef = ref<any>();
const viewerFile = ref();
const feedbackUserSelectProps = {
  allowClear: true,
  showSearch: true,
  style: { width: "100%" },
  getPopupContainer: (triggerNode: HTMLElement) => triggerNode.parentElement,
};
const formState: any = ref({
  blNo: "",
  number: "",
  truckPlateNumber: "",
  orderNo: "",
  feedbackUserId: null,
  remark: "",
  fileName: "",
});
const uploadConfig = {
  code: "document-and-certificate",
  bizKey: "customs-declaration",
  bizType: "customs-declaration",
  showFileSearch: true,
  autoUpload: true,
};
const fileUploadInfo: any = {
  fileType: ["jpg", "png", "jpeg", "gif", "JPG", "PNG", "JPEG", "GIF"],
};
const feedbackFileUrlList = computed<string[]>(() => {
  const list: string[] = [];
  for (const vo of fileList) {
    if (vo.fileUrl && vo.status == "uploaded") {
      list.push(vo.fileUrl);
    }
  }
  return list;
});
const uploadService = new YzsFileService({
  bizKey: uploadConfig.bizKey,
  bizType: uploadConfig.bizType,
  basePrefix: "/api",
  generateMate: function () {
    return {
      client: "PC",
      code: uploadConfig.code,
      tag: "string",
      time: new Date().getTime(),
    };
  },
  generateHeaders: function () {
    return {
      Authorization: localStorage.getItem("login-token") || "",
    };
  },
});

function getContainer() {
  //兼容不适用通用组件的情况
  if (document.querySelector(".porta-renderer-wrapper")) {
    return document.querySelector(".porta-renderer-wrapper");
  }
  if (document.querySelector(".main__container")) {
    return document.querySelector(".main__container");
  }
  return false;
}
const visible = ref(false);
const postLoading = ref(false); // Add postLoading property

function objectToURLSearchParams(obj: any) {
  const searchParams = new URLSearchParams();
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      searchParams.append(key, obj[key]);
    }
  }
  return searchParams.toString();
}

function handleUplaodChange(fileInfo: FileInfo) {
  const key = fileInfo.fileKey;
  if (fileInfo.file.size == 0) {
    message.warning(t("fileSizeIsEmpty"));
    return;
  }
  if (fileUploadInfo) {
    if (fileInfo.file.size > fileUploadInfo.fileMaxSize) {
      let mNumber = fileUploadInfo.fileMaxSize / 1024 / 1024;
      message.warning(`${t("fileSizeExceeds")}，${mNumber}M${t("unableToUpload")}`);
      return;
    }
  }
  let keyIndex = fileList.findIndex((v: any) => v.fileKey === key);
  if (keyIndex < 0) {
    if (fileUploadInfo && fileUploadInfo.fileType.length) {
      let checkStatus = checkFileType(fileInfo.file, fileUploadInfo.fileType);
      if (!checkStatus) {
        let text =
          t("supportedFileFormats") +
          fileUploadInfo.fileType.reduce((preVo: any, curVo: any) => {
            return (preVo += "." + curVo + "、");
          }, "");
        message.warning(text);
        return;
      }
      updateFileList("add", {
        fileKey: fileInfo.fileKey,
        fileName: fileInfo.fileName,
        file: fileInfo.file,
        status: "notUploaded",
        progress: null,
      });

      console.log(fileInfo, "fileInfo");
    }
  }
  upload();

  // formState.value.feedbackFileUrlList.push(fileInfo);
}

function updateFileList(active: string, value: any) {
  //   let oldValue = [...fileList];
  if (active === "add") {
    fileList.push(value);
    return fileList;
  }
  if (active === "delete") {
    let vo = fileList.splice(value.start, value.end);
    return vo;
  }
}

async function postUploadFile(fileInfo: FileInfo) {
  if (fileInfo.status == "uploaded") {
    console.log("已经上传的文件不在上传");
    return;
  }
  if (!fileInfo.file) {
    console.error("缺少文件");
    return;
  }

  if (!uploadService) {
    message.error(t("fileUplaodInitFailed"));
    return;
  }
  const result = await uploadService.uploadFile({
    file: fileInfo.file,
    onUploadProgress: (progress: number) => {
      fileInfo.progress = progress;
      if (fileInfo.progress < 100) {
        fileInfo.status = "uploading";
      } else {
        fileInfo.status = "uploaded";
      }

      // console.log(progress);
    },
  });
  if (result.success) {
    const key = fileInfo.fileKey;
    let keyIndex = fileList.findIndex((v: any) => v.fileKey === key);
    if (keyIndex >= 0) {
      fileList[keyIndex].fileUrl = result.fileUrl;
      fileList[keyIndex].status = "uploaded";
    }
  }
  return result;
}

async function upload() {
  let postList = fileList.filter((v: any) => {
    let status = v.status === "notUploaded" || v.status === "uploadFailed";
    return status;
  });
  let asyncList = [];
  for (let item of postList) {
    asyncList.push(postUploadFile(item));
  }
  const result = await Promise.all(asyncList);
  let isErr = false;
  for (let vo of result) {
    if (vo && !vo.success) {
      if (!isErr) {
        isErr = true;
      }
      message.warning(vo.msg);
    }
  }
  let files = toRaw(fileList);
}
async function handleDelete(option: any) {
  updateFileList("delete", {
    start: option.index,
    end: 1,
  });
}

function handleClickFile(object: FileInfo) {
  // console.log(object, "object");
  viewerFile.value.viewer(object.fileUrl);
}

function openModal() {
  visible.value = true;
}
function afterClose() {
  fileList.splice(0, fileList.length);
  formState.value = {
    blNo: "",
    number: "",
    truckPlateNumber: "",
    orderNo: "",
    feedbackUserId: null,
    remark: "",
    fileName: "",
  };
  formRef.value?.resetFields?.();
}
async function handleSubmit() {
  const payload = {
    ...formState.value,
  };
  const urlList: any = toRaw(feedbackFileUrlList.value);
  if (!urlList || urlList.length === 0) {
    message.warning(t("pleaseUploadFileOrImg"));
    return;
  }
  const result = await apiPostProblemfeedback({
    ...payload,
    feedbackFileUrlList: urlList,
  });
  if (result.success) {
    message.success(t("submittedSuccessfully"));

    visible.value = false;
  }
  console.log(result, "resultresult");
}

async function handleSubmitClick() {
  try {
    await formRef.value?.validate();
    await handleSubmit();
  } catch {
    // 表单校验失败时，交给 a-form 展示字段错误提示。
  }
}

watch(visible, (vo: any) => {
  if (!vo) {
    afterClose();
  }
});

defineExpose({
  openModal,
});
</script>
<style lang="scss" scoped>
.base-upload {
  position: relative;

  :deep(.ant-upload-text) {
    position: relative;
    font-size: 14px;
  }

  :deep(.ant-upload-text .local-file) {
    font-size: 14px !important;
  }
}

:deep(.feedback-user-select .ant-select-selector) {
  background-color: #fff !important;
}

:deep(.feedback-user-select.fuzzy-select-selector-active .ant-select-selector) {
  background-color: #fff !important;
}
</style>
